import {getThirdPartyUsageCSVDataLink} from "./thirdPartyUsageCSVDownloadHelper";
import downloadIconSrc from "../../Resources/Image/sd-download.svg";

export const getThirdPartyUsageTable = (weekBasedData, accountData) => {
    //Date, Company name, delivery fees, tips, third party total, paid, unpaid for csv
    // date, total billing, outstanding, details
    let tableRowArr = [];
    for (const week in weekBasedData) {
        let tableCol = [];
        let weekLastDate = getLastWeekDate(week);
        tableCol.push(weekLastDate);
        tableCol.push(weekBasedData[week].total);
        //tableCol.push(weekBasedData[week].totalPaid);
        tableCol.push(weekBasedData[week].outstandingAmount);
        let fileName = "thirdParty_details_" + weekLastDate;
        let downloadCSV = getThirdPartyUsageCSVDataLink(fileName, weekLastDate,
            weekBasedData[week].billingInfos, accountData);
        tableCol.push(downloadCSV);
        tableRowArr.push(tableCol);
    }
    return tableRowArr.sort(sortByWeek);
}

const sortByWeek = (week1, week2) => {
    try {
        let w1 = new Date(week1[0]);
        let w2 = new Date(week2[0]);
        return w2.getTime() - w1.getTime();
    } catch (e) {
        return;
    }
}

const getLastWeekDate = (weekStr) => {
    let [year, month, date] = weekStr.split('-');
    return date + "/" + month + "/" + year;
}

export const getThirdPartyListTable = (thirdPartyList, handleDownload) => {
    //Date, Company name, delivery fees, tips, third party total, paid, unpaid for csv
    // date, total billing, outstanding, details
    let tableRowArr = [];
    thirdPartyList.forEach((item) => {
        let tableCol = [];
        let weekLastDate = getLastWeekDate(item.billingDate);
        tableCol.push(weekLastDate);
        tableCol.push(item.billableAmount);
        //tableCol.push(thirdPartyList[week].totalPaid);
        tableCol.push(item.outstandingAmount);
        // let downloadCSV = getThirdPartyUsageCSVDataLink(fileName, weekLastDate,
        //     weekBasedData[week].billingInfos, accountData);
        let downloadButton = getDownloadButton(item.billingDate, handleDownload);
        tableCol.push(downloadButton);
        tableRowArr.push(tableCol);
    });
    return tableRowArr.sort(sortByWeek);
}

const getDownloadButton = (billingDate, handleDownload) => (
  <button
    className="downloadBtn"
    type="button"
    onClick={() => handleDownload(billingDate)}
    title="Download Details"
  >
    <img src={downloadIconSrc} alt="download" />
  </button>
);
